import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/chain/zksyncera_24.svg.ts
import { svg } from "lit";
var zkSyncEra24Svg = ({ width, height }) => svg`
<svg width="${width ?? 24}" height="${height ?? 24}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="12" fill="#1E69FF"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.26626 16.5L3.75 12L8.26626 7.5V9.9L12.75 9.90382L8.26626 13.2306V16.5ZM15.7337 7.5L20.2499 12.0009L15.7337 16.5V14.0986L11.2499 14.0948L15.7337 10.7955V7.5Z" fill="white"/>
</svg>
`;
export {
  zkSyncEra24Svg
};
//# sourceMappingURL=zksyncera_24.svg-6GCDLJI2.js.map
